/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import React from "react";
import PaymentDataContent from "components/content/PaymentDataContent";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";
import { useSearchParams } from "react-router-dom";

/**
 * Payment processing and management page.
 * Handles patient payment entry and transaction processing.
 * 
 * Features:
 * - Payment amount entry
 * - Payment method selection (cash, check, card, insurance)
 * - Patient account selection
 * - Outstanding balance display
 * - Payment application to specific charges
 * - Receipt generation and printing
 * - Payment history tracking
 * - Integration with accounting movements
 * - Automatic balance calculation
 * 
 * The page receives accountingId via URL query parameter
 * to pre-select the patient account for payment.
 * 
 * @returns {JSX.Element} Payment processing page component
 */
const PaymentPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const accountingId = searchParams.get("accountingId") || "";

  return (
    <DefaultDashboardLayout>
      <PaymentDataContent accountingId={accountingId} />
    </DefaultDashboardLayout>
  );
};

export default PaymentPage;

